import { Spin } from 'antd';

export interface LoaderOverlayProps {
  isLoading: boolean;
}

export function LoaderOverlay({ isLoading }: Readonly<LoaderOverlayProps>) {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(255,255,255,0.7)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin size="large" aria-label="Loading..." />
    </div>
  );
}
